function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import BaseModule from './BaseModule';

var DisplaySize = /*#__PURE__*/function (_BaseModule) {
  _inherits(DisplaySize, _BaseModule);

  var _super = _createSuper(DisplaySize);

  function DisplaySize() {
    _classCallCheck(this, DisplaySize);

    return _super.apply(this, arguments);
  }

  _createClass(DisplaySize, [{
    key: "onCreate",
    value: function onCreate() {
      // Create the container to hold the size display
      this.display = document.createElement('div'); // Apply styles

      Object.assign(this.display.style, this.options.styles.display); // Attach it

      this.overlay.appendChild(this.display);
    }
  }, {
    key: "onUpdate",
    value: function onUpdate() {
      if (!this.display || !this.activeEle) {
        return;
      }

      var size = this.getCurrentSize();
      this.display.innerHTML = size.join(' &times; ');

      if (size[0] > 120 && size[1] > 30) {
        // position on top of image
        Object.assign(this.display.style, {
          right: '4px',
          bottom: '4px',
          left: 'auto'
        });
      } else if (this.activeEle.style.float === 'right') {
        // position off bottom left
        var displayRect = this.display.getBoundingClientRect();
        Object.assign(this.display.style, {
          right: 'auto',
          bottom: "-".concat(displayRect.height + 4, "px"),
          left: "-".concat(displayRect.width + 4, "px")
        });
      } else {
        // position off bottom right
        var _displayRect = this.display.getBoundingClientRect();

        Object.assign(this.display.style, {
          right: "-".concat(_displayRect.width + 4, "px"),
          bottom: "-".concat(_displayRect.height + 4, "px"),
          left: 'auto'
        });
      }
    }
  }, {
    key: "getCurrentSize",
    value: function getCurrentSize() {
      return [this.activeEle.offsetWidth, this.activeEle.offsetHeight];
    }
  }]);

  return DisplaySize;
}(BaseModule);

export { DisplaySize as default };